<template>
  <Layout>
    <PageHeader
      :items="items"
    />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">{{ editMode ? 'Edición' : 'Creación' + ' de Formulario' }}</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'formList' }"
          >
            <b-icon
              class="icon-plus"
              icon="arrow90deg-left"
            ></b-icon>
          </router-link>
        </span>
      </div>
      <div class="card-app">
        <b-container fluid>
          <b-overlay
            :show="isSaving"
            blur="5px"
            :opacity="1"
            variant="transparent"
            spinner-variant="primary"
            spinner-type="grow"
            rounded="sm"
          >
            <ValidationObserver
              id="typeForm"
              ref="observer"
              v-slot="{ handleSubmit }"
            >
              <b-tabs
                v-model="tabIndex"
                ref="tabs"
                small
                card
                @activate-tab="tabActivated"
                class="tabs-forms"
              >
                <ValidationObserver ref="obs0">
                  <b-tab id="obs0" title="Ficha Técnica" class="p-2 pt-3">
                    <div class="row no-gutters">
                      <div class="col-md-12 col-sm-12">
                        <div class="row">
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputText
                              id="title"
                              name="title"
                              label="Título"
                              autocomplete="title"
                              :autofocus="true"
                              validationMode="aggressive"
                              validate="max:250|required"
                              placeholder="Escriba el titulo de su formulario"
                              :value.sync="form.title"
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputCheckbox
                              id="fillByHouseHold"
                              name="fillByHouseHold"
                              label="¿Es un formulario a nivel hogar?"
                              innerLabel="No / Si"
                              :value.sync="form.fillByHouseHold"
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="secretaries"
                              name="secretaries"
                              label="Secretarías"
                              placeholder="Seleccione secretaría"
                              trackBy="id"
                              validate="required"
                              :value.sync="secretaries"
                              :closeOnSelect="false"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :loading="secretariesLoading"
                              :custom-label="(t) => t.name"
                              :options="secretariesOptions"
                              :required="true"
                              :multiple="true"
                            />
                            <!-- compress-selection-label -->
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="state"
                              name="state"
                              label="Estado"
                              placeholder="Seleccione Estado"
                              trackBy="id"
                              :value.sync="form.state"
                              :closeOnSelect="true"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :custom-label="(t) => t.name"
                              :options="stateOptions"
                              validate="required"
                              :multiple="false"
                            />
                            <!-- {{ form }} -->
                          </div>
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <InputTextarea
                              id="goal"
                              name="goal"
                              label="Objetivo"
                              autocomplete="goal"
                              validationMode="aggressive"
                              validate="max:500"
                              :rows="3"
                              placeholder="Escriba una breve descripción del objetivo con el formulario"
                              :value.sync="form.goal"
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="populationType"
                              name="populationType"
                              label="Tipo Cobertura Geográfica"
                              placeholder="Seleccione tipo"
                              trackBy="id"
                              :value.sync="form.populationType"
                              :closeOnSelect="true"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :custom-label="(t) => t.name"
                              :options="populationTypeOptions"
                              :multiple="false"
                              :onchange="getCommunesOptions"
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="commune"
                              name="commune"
                              label="Comuna"
                              placeholder="Seleccione comuna"
                              trackBy="id"
                              :value.sync="communes"
                              :closeOnSelect="false"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :custom-label="
                                (t) =>
                                  `${t.name} (${
                                    t.number
                                      ? 'Comuna ' + t.number
                                      : 'Corregimiento'
                                  })`
                              "
                              :options="communesOptions"
                              :loading="communesLoading"
                              :disabled="form.populationType.id === 'all'"
                              :multiple="true"
                            />
                          </div>

                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="neighborhood"
                              name="neighborhood"
                              label="Barrio"
                              placeholder="Seleccione barrio"
                              trackBy="id"
                              :value.sync="form.neighborhoods"
                              :closeOnSelect="false"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :custom-label="(t) => t.name"
                              :options="neighborhoodsOptions"
                              :loading="neighborhoodsLoading"
                              :disabled="form.populationType.id === 'all'"
                              :multiple="true"
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputText
                              id="geographicCoverage"
                              name="geographicCoverage"
                              label="Cobertura Geográfica - Información Adicional"
                              autocomplete="geographicCoverage"
                              validationMode="aggressive"
                              validate="max:500"
                              placeholder="Describa la Cobertura"
                              :value.sync="form.geographicCoverage"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12">
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <InputTextarea
                              id="targetPopulation"
                              name="targetPopulation"
                              label="Población Objetivo"
                              autocomplete="targetPopulation"
                              validationMode="aggressive"
                              validate="max:500"
                              :rows="3"
                              placeholder="Describa la población objetivo"
                              :value.sync="form.targetPopulation"
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="indicators"
                              name="indicators"
                              label="Principales Indicadores"
                              placeholder="Seleccione indicador"
                              trackBy="id"
                              :value.sync="form.indicators"
                              :closeOnSelect="false"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :loading="indicatorsLoading"
                              :custom-label="
                                (t) => `${t.name} (${t.secretaryship_name})`
                              "
                              :options="indicatorsOptions"
                              :multiple="true"
                              :noOptions="
                                form.secretaries.length > 0
                                  ? 'Sin indicadores'
                                  : 'Seleccione Secretaría'
                              "
                            />
                            <!-- compress-selection-label -->
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="project"
                              name="project"
                              label="Proyecto"
                              placeholder="Seleccione Proyecto"
                              trackBy="id"
                              :value.sync="form.project"
                              :closeOnSelect="true"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :loading="projectsLoading"
                              :custom-label="
                                (t) => `${t.name} (${t.secretaryship_name})`
                              "
                              :options="projectsOptions"
                              :multiple="false"
                              :noOptions="
                                form.secretaries.length > 0
                                  ? 'Sin proyectos'
                                  : 'Seleccione Secretaría'
                              "
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputCheckbox
                              id="isPermanent"
                              name="isPermanent"
                              label="Tipo Caracterización"
                              innerLabel="Permanente"
                              :value.sync="form.isPermanent"
                            />
                          </div>
                          <div class="col-12 mb-3" v-if="form.isPermanent">
                            <div class="row">
                              <label>Periodo de Recolección</label>
                            </div>
                            <div class="row">
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                <input-date label="Desde" :value.sync="form.startAt" />
                                <!-- <label for="date-from">Desde</label>
                                <b-form-datepicker
                                  id="date-from"
                                  placeholder="Desde"
                                  locale="es"
                                  v-model="form.startAt"
                                  hide-header
                                  :disabled="!form.isPermanent"
                                  label-help="Seleccione una fecha"
                                  :date-format-options="{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                  }"
                                >
                                </b-form-datepicker> -->
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                <input-date label="Hasta" :value.sync="form.endAt" />
                                <!-- <label for="date-until">Hasta</label>
                                <b-form-datepicker
                                  id="date-until"
                                  placeholder="Hasta"
                                  locale="es"
                                  v-model="form.endAt"
                                  hide-header
                                  :disabled="!form.isPermanent"
                                  label-help="Seleccione una fecha"
                                  :date-format-options="{
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                  }"
                                >
                                </b-form-datepicker> -->
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputText
                              id="periodicity"
                              name="periodicity"
                              label="Periodicidad"
                              type="number"
                              autocomplete="periodicity"
                              validationMode="aggressive"
                              validate="minmax:0,999"
                              placeholder="Periodicidad"
                              :value.sync="form.periodicity"
                            />
                          </div>
                          <div class="col-lg-6 col-md-12 col-sm-12">
                            <InputMultiSelect
                              id="timeFrame"
                              name="timeFrame"
                              label="Periodo de Tiempo"
                              placeholder="Seleccione Periodo"
                              trackBy="id"
                              :value.sync="form.timeFrame"
                              :closeOnSelect="true"
                              selectLabel="✚"
                              selectedLabel="✓"
                              deselectLabel="✖"
                              :custom-label="(t) => t.name"
                              :options="timeFrameOptions"
                              :multiple="false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </ValidationObserver>
                <b-tab
                  id="obs1"
                  title="Variables Base"
                  class="base-vars p-2"
                  v-if="!secretariesLoading"
                  :disabled="form.id === null"
                >
                  <b-card
                    v-for="(dimension, key) in dimensions"
                    :key="key"
                    no-body
                    class="section-card"
                    v-show="dimension.base_variables.length > 0"
                  >
                    <b-card-header class="pl-2 bg-transparent">
                      <h6 class="text-primary">{{ dimension.name }} </h6>
                    </b-card-header>
                    <b-card-body class="p-0">
                      <div class="row">
                        <div
                          class="col-md-6"
                          v-for="(variable, index) in dimension.base_variables"
                          :key="index"
                        >
                          <renderVariable
                            :variable="variable"
                            :isPreview="true"
                          />
                        </div>
                      </div>
                    </b-card-body>
                  </b-card>
                </b-tab>

                <b-tab
                  id="obs2"
                  title="Variables Extendidas"
                  class="extended-vars p-0"
                  :disabled="form.id === null"
                >
                  <div class="row no-gutters" v-if="tabIndex == 2">
                    <div class="col-md-4 col-lg-4 col-xl-3 bg-white left-panel">
                      <div class="p-2 bg-white">
                        <form class="search">
                          <div class="my-search-box">
                            <div class="input-group">
                              <input
                                ref="extVarSearch"
                                type="text"
                                class="form-control"
                                placeholder="Buscar Variable"
                                v-model="extendedVariableSearch"
                              />
                              <div class="input-group-append">
                                <b-button
                                  class="btn"
                                  @click="
                                    extendedVariableSearch = ''
                                    $refs.extVarSearch.focus()
                                  "
                                >
                                  <em
                                    :class="{
                                      'fe-search':
                                        extendedVariableSearch === '',
                                      'fe-x': extendedVariableSearch !== '',
                                    }"
                                  ></em>
                                </b-button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="accordion" role="tablist">
                        <div
                          v-for="(dimension, key) in dimensionsOrder"
                          :key="key"
                        >
                          <b-card
                            v-if="
                              getVariableSearch(
                                dimension.extended_variables,
                                extendedVariableSearch
                              ).length > 0
                            "
                            no-body
                            class="m-0"
                          >
                            <b-card-header
                              class="p-1 dimension-title"
                              role="tab"
                            >
                              <b-button
                                block
                                v-b-toggle="`accordion-${key}`"
                                variant="link"
                                class="text-left text-dark font-weight-bold"
                                >{{ dimension.name }}
                                <span class="font-weight-normal text-muted"
                                  >({{
                                    getVariableSearch(
                                      dimension.extended_variables,
                                      extendedVariableSearch
                                    ).length
                                  }})</span
                                >
                                <span>
                                  <font-awesome-icon
                                    icon="chevron-down"
                                    class="opened"
                                  />
                                  <font-awesome-icon
                                    icon="chevron-right"
                                    class="closed"
                                  />
                                </span>
                              </b-button>
                            </b-card-header>
                            <b-card-body class="py-0 px-2 m-0 ">
                              <b-collapse
                                :id="`accordion-${key}`"
                                accordion="my-accordion"
                                role="tabpanel"
                              >
                                <DropList
                                  :items="
                                    dimension.extended_variables
                                      .filter((varia) => {
                                        return (
                                          varia.label.toLowerCase() +
                                          ' ' +
                                          varia.description.toLowerCase()
                                        ).includes(
                                          extendedVariableSearch.toLowerCase()
                                        )
                                      })
                                      .sort((a, b) => {
                                        if (a.label > b.label) {
                                          return 1
                                        }
                                        if (a.label < b.label) {
                                          return -1
                                        }
                                        return 0
                                      })
                                  "
                                  @reorder="
                                    $event.apply(dimension.extended_variables)
                                  "
                                  @insert="
                                    insertSection(
                                      $event,
                                      dimension.extended_variables
                                    )
                                  "
                                  mode="cut"
                                >
                                  <template v-slot:item="{ item, reorder }">
                                    <Drag
                                      :key="item.id + item.label"
                                      :data="item"
                                      :vibration="10"
                                      :go-back="true"
                                      @cut="
                                        removeVariable(
                                          dimension.extended_variables,
                                          item
                                        )
                                      "
                                      @dblclick.native="
                                        onDrop({ data: item })
                                        removeVariable(
                                          dimension.extended_variables,
                                          item
                                        )
                                      "
                                    >
                                      <b-list-group>
                                        <b-list-group-item
                                          class="pl-1 mb-1 p-1"
                                          :class="reorder ? 'bg-primary' : null"
                                        >
                                          <b-icon
                                            icon="three-dots-vertical"
                                            class="ml-0 mr-1 text-muted"
                                            font-scale="1.2"
                                          >
                                          </b-icon>
                                          <b-icon
                                            :icon="
                                              $store.state.variables.variableIcons.filter(
                                                (icon) => icon.key === item.type
                                              )[0].value
                                            "
                                            class="mr-1 text-info"
                                            font-scale="1.1"
                                          ></b-icon>
                                          {{ item.label }}
                                        </b-list-group-item>
                                      </b-list-group>
                                    </Drag>
                                  </template>
                                </DropList>
                              </b-collapse>
                            </b-card-body>
                          </b-card>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 col-lg-8 col-xl-9 p-2">
                      <Drop
                        class="section-card list2 empty mt-2"
                        @drop="onDrop"
                        mode="cut"
                      >
                      </Drop>
                      <div v-if="extended_variables.length">
                        <div
                          v-if="extended_variables[0].items.length === 0"
                          class="p-3 rounded justify-content-center text-center"
                        >
                          <h6 class="mb-0"
                            ><b
                              >Arrastre la variable que desee agregar al
                              formulario</b
                            ></h6
                          >
                        </div>

                        <div
                          v-for="(section, index) in extended_variables"
                          :key="index"
                        >
                          <div
                            v-if="Object.keys(section.items).length > 0"
                            :ref="`section-${section.id}`"
                            class="section-card pb-2"
                            :data-change="lastChange"
                          >
                            <h6 class="mb-0 ml-1 pt-2 px-2">
                              <b>{{ section.name }}</b>
                              <b-button
                                v-if="
                                  index !== 0 &&
                                    extended_variables.filter(
                                      (x) => x.items.length > 0
                                    ).length > 1
                                "
                                variant="link"
                                class="p-0 m-0 ml-1"
                                @click="moveSection(index, index - 1)"
                                v-b-tooltip.hover="{
                                  variant: 'info',
                                  title: 'Subir sección',
                                }"
                              >
                                <b-icon
                                  icon="arrow-up"
                                  class="text-info"
                                  font-scale="1.2"
                                />
                              </b-button>
                              <b-button
                                v-if="index !== extended_variables.length - 1"
                                variant="link"
                                class="p-0 m-0 ml-1"
                                @click="moveSection(index, index + 1)"
                                v-b-tooltip.hover="{
                                  variant: 'info',
                                  title: 'Bajar sección',
                                }"
                              >
                                <b-icon
                                  icon="arrow-down"
                                  class="text-info"
                                  font-scale="1.2"
                                />
                              </b-button>
                            </h6>
                            <DropList
                              class="list2 pt-2 pb-0"
                              :class="{
                                empty: Object.keys(section.items).length === 0,
                              }"
                              :items="section.items"
                              @reorder="$event.apply(section.items)"
                              @drop="onDrop"
                              @dragover="dragOver"
                              mode="cut"
                              :accepts-data="
                                (d) => d.dimension === section.dimension_id
                              "
                            >
                              <template
                                v-slot:item="{ item, reorder }"
                                :data-change="lastChange"
                              >
                                <Drag
                                  :key="
                                    `section-${index}-item-${item.variable}`
                                  "
                                  :data="item"
                                  :data-change="lastChange"
                                  @cut="removeVariable(section.items, item)"
                                  class="col-md-12 col-lg-9 col-xl-8 col-xxl-6"
                                  :vibration="10"
                                  handle=".card-subtitle"
                                >
                                  <b-card
                                    :bg-variant="reorder ? 'primary' : null"
                                    no-body
                                    class="mb-2 shadow rounded-5"
                                    :data-change="lastChange"
                                    :class="{
                                      dependent: 'depends' in item.extra_config,
                                    }"
                                  >
                                    <b-card-sub-title
                                      handle
                                      class="m-0 pt-1 px-1 text-warning handle-cursor"
                                    >
                                      <b-badge
                                        pill
                                        class="badge"
                                        variant="primary"
                                        v-if="
                                          'dependents' in item.extra_config &&
                                            item.extra_config.dependents
                                              .length > 0
                                        "
                                        v-b-tooltip.hover="{
                                          variant: 'primary',
                                          html: true,
                                          title: extended_variables
                                            .map((y) => y.items)
                                            .reduce((pre, cur) => {
                                              return pre.concat(cur)
                                            })
                                            .filter(
                                              (x) =>
                                                item.extra_config.dependents &&
                                                item.extra_config.dependents.indexOf(
                                                  parseInt(x.variable)
                                                ) > -1
                                            )
                                            .map((y) => y.label)
                                            .join('<br>'),
                                        }"
                                      >
                                        {{
                                          item.extra_config.dependents.length
                                        }}
                                        variables deps
                                      </b-badge>
                                      <small
                                        class="text-warning"
                                        v-if="'depends' in item.extra_config"
                                      >
                                        <b-badge
                                          pill
                                          class="badge"
                                          variant="warning"
                                          >{{
                                            item.extra_config.depends_condition
                                          }}</b-badge
                                        >
                                        {{
                                          getVariableInfoById(
                                            item.extra_config.depends
                                          ).label
                                        }}
                                        {{ item.extra_config.depends_value }}
                                      </small>
                                      <b-icon
                                        icon="arrows-move"
                                        class="float-right text-info m-0 ml-1"
                                        font-scale="1.1"
                                      >
                                      </b-icon>
                                      <b-button
                                        @click="openModalExtraConfig(item)"
                                        v-b-tooltip.hover="{
                                          variant: 'info',
                                          title: 'Definir configuración extra',
                                        }"
                                        class="float-right m-0 p-0 ml-1"
                                        variant="link"
                                      >
                                        <b-icon
                                          icon="three-dots"
                                          class="text-info"
                                          font-scale="1.4"
                                        ></b-icon>
                                      </b-button>
                                    </b-card-sub-title>
                                    <b-card-body class="px-2 pt-1 pb-1 m-0">
                                      <renderVariable
                                        :variable="item"
                                        :isComponent="true"
                                        :removeButton="
                                          'dependents' in item.extra_config &&
                                          item.extra_config.dependents.length >
                                            0
                                            ? false
                                            : true
                                        "
                                        @remove="
                                          removeVariable(
                                            section.items,
                                            item,
                                            'restore'
                                          )
                                        "
                                      />
                                    </b-card-body>
                                  </b-card>
                                </Drag>
                              </template>
                              <template v-slot:feedback="{ data }">
                                <b-card
                                  bg-variant="light"
                                  class="col-md-12 col-lg-9 col-xl-8 col-xxl-6 p-1 mt-2 mb-1 px-3 shadow rounded-5"
                                  :key="
                                    `temp-section-${index}-item-${
                                      data.variable
                                    }`
                                  "
                                >
                                  Suelte aquí para insertar la variable
                                  <b>{{ data.label }}</b>
                                </b-card>
                              </template>
                            </DropList>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <template #tabs-end>
                  <li
                    role="presentation"
                    class="nav-item align-self-center text-muted pl-4"
                    style="width: 97%;
                      text-align: end;"
                  >
                    Estado:
                    <span
                      :class="{
                        'text-danger': form.pub_state === '',
                        'text-warning':
                          form.pub_state === 'N' || form.pub_state === 'X',
                        'text-success': form.pub_state === 'P',
                      }"
                      >{{
                        editMode
                          ? pubStatesOptions
                              .filter((x) => x.id === form.pub_state)
                              .map((y) => y.text)[0]
                          : `Sin Guardar`
                      }}</span
                    >
                    <b-button
                      size="sm"
                      variant="transparent"
                      class="ml-2"
                      @click="previewForm"
                      v-b-tooltip.hover="{
                        variant: 'info',
                        title: 'Previsualizar Formulario',
                      }"
                    >
                      <b-icon-eye />
                    </b-button>
                    <b-button
                      v-if="form.id"
                      size="sm"
                      variant="transparent"
                      class="ml-2"
                      @click="managersForm"
                      v-b-tooltip.hover="{
                        variant: 'info',
                        title: 'Asociar Gestores',
                      }"
                    >
                      <b-icon-person-plus />
                    </b-button>
                    <b-button
                      v-if="form.pub_state === 'N' || form.pub_state === 'X'"
                      size="sm"
                      variant="primary"
                      pill
                      class="ml-2"
                      @click="saveForm('publicate')"
                      >Publicar</b-button
                    >
                    <b-button
                      v-if="form.pub_state === 'P'"
                      size="sm"
                      variant="warning"
                      pill
                      class="ml-2"
                      @click="saveForm('pause')"
                      >Pausar</b-button
                    >
                  </li>
                </template>
              </b-tabs>
              <!-- Control buttons-->
              <div
                class="row p-1 bg-white with-separator fixed-buttons height-content-footer"
              >
                <div class="col-md-12">
                  <b-button
                    v-if="tabIndex > 0"
                    variant="outline-primary button-footer-2"
                    pill
                    @click="tabIndex--"
                    >Atrás</b-button
                  >
                  <b-button
                    v-if="tabIndex !== 2 && !secretariesLoading"
                    class="float-right"
                    variant="primary button-footer-1"
                    pill
                    @click="handleSubmit(saveForm)"
                    >Siguiente</b-button
                  >
                  <b-button
                    v-if="tabIndex == 2"
                    class="float-right"
                    variant="primary button-footer-1"
                    pill
                    @click="saveForm"
                    :disabled="form.id === null"
                    v-b-tooltip.hover="{
                      variant: form.id === null ? 'danger' : 'info',
                      title:
                        form.id === null
                          ? 'No ha guardado el formulario'
                          : 'Guardar variables extendidas',
                    }"
                    >Guardar</b-button
                  >
                </div>
              </div>
            </ValidationObserver>
          </b-overlay>
        </b-container>
      </div>
    </div>

    <b-modal
      v-model="modalPreview"
      id="preview-modal"
      size="lg"
      :title="`Previsualización - ${form.title || 'Sin nombrar'}`"
      ok-only
      ok-title="Aceptar"
    >
      <b-tabs>
        <b-tab id="obsprw1" title="Variables Base" class="base-vars p-2">
          <b-card
            v-for="(dimension, key) in dimensions"
            :key="key"
            no-body
            class="section-card"
            v-show="
              Object.keys(dimension.base_variables).length > 0 ||
                Object.keys(
                  extended_variables.find(
                    (x) => x.dimension_id === dimension.id
                  ) || {}
                ).length > 0
            "
          >
            <b-card-header class="pl-2 bg-transparent">
              <h6 class="text-primary"
                >{{ dimension.name }}
                <small class="text-muted">{{ dimension.description }}</small>
              </h6>
            </b-card-header>
            <b-card-body class="p-0">
              <div class="row">
                <div
                  class="col-md-6"
                  v-for="(variable, index) in dimension.base_variables"
                  :key="`prev-dim-${dimension.id}-base-${index}-${variable.id}`"
                >
                  <renderVariable
                    :variable="variable"
                    :isComponent="true"
                    :isPreview="false"
                    :hiddenRequired="false"
                  />
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-tab>
        <b-tab
          id="obsprw2"
          title="Variables Extendidas"
          class="extended-vars p-0"
        >
          <b-card
            v-for="(dimension, key) in dimensions"
            :key="key"
            no-body
            class="section-card"
            v-show="
              Object.keys(
                extended_variables.find(
                  (x) => x.dimension_id === dimension.id
                ) || {}
              ).length > 0
            "
          >
            <b-card-header class="pl-2 bg-transparent">
              <h6 class="text-primary"
                >{{ dimension.name }}
                <small class="text-muted">{{ dimension.description }}</small>
              </h6>
            </b-card-header>
            <b-card-body class="p-0">
              <div class="row">
                <div
                  class="col-md-6"
                  v-for="(variable, index2) in Object.keys(
                    extended_variables.find(
                      (x) => x.dimension_id === dimension.id
                    ) || {}
                  ).length > 0
                    ? extended_variables.find(
                        (x) => x.dimension_id === dimension.id
                      ).items
                    : {}"
                  :key="`prev-dim-${dimension.id}-var-${index2}-${variable.id}`"
                >
                  <renderVariable
                    :variable="variable"
                    :isComponent="true"
                    :isPreview="false"
                    :removeButton="
                      'dependents' in variable.extra_config &&
                      variable.extra_config.dependents.length > 0
                        ? false
                        : true
                    "
                    @remove="
                      removeVariable(
                        extended_variables.find(
                          (x) => x.dimension_id === dimension.id
                        ).items,
                        variable,
                        'restore'
                      )
                    "
                  />
                </div>
              </div>
            </b-card-body>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-modal>

    <b-modal
      v-model="modalManagers"
      id="managers-modal"
      size="lg"
      :title="`Asociar Gestores - ${form.title || 'Sin nombrar'}`"
      ok-only
      ok-title="Guardar"
      @ok="saveManagers"
    >
      <b-row>
        <InputMultiSelect
          id="managers"
          name="managers"
          label="Gestores"
          placeholder="Seleccione Gestores"
          trackBy="id"
          :taggable="true"
          :value.sync="form.managers"
          :closeOnSelect="false"
          selectLabel="✚"
          selectedLabel="✓"
          deselectLabel="✖"
          :tagAction="addManager"
          :custom-label="(t) => t.name"
          :options="managersOptions"
          :required="true"
          :multiple="true"
        />
      </b-row>
      <b-row>
        <b-col lg="7" md="7" sm="12" xs="12">
          <b-alert
            :show="showDismissibleManagerAlert"
            variant="warning"
            dismissible
            @dismissed="showDismissibleManagerAlert = false"
          >
            <b-icon-exclamation-circle font-scale="1.5" class="mr-1" />
            <b>{{ managersError.title }}:</b>
            <ul>
              <li v-for="error in managersError.errors" :key="error">{{
                error
              }}</li>
            </ul>
          </b-alert>
        </b-col>
        <b-col lg="5" md="5" sm="12" xs="12">
          <CsvLoader
            ref="fileLoader"
            v-on:loadSuccess="loadSuccess"
            class="float-right"
          ></CsvLoader>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-model="modalExtraConfig"
      id="extra-config-modal"
      size="md"
      title="Definir Configuración"
    >
      <div v-if="Object.keys(dependentVariable).length > 0">
        <b-form-select
          v-model="dependentVariable.variable"
          @change="dependentVariable.condition = 'IN'"
          class="col-md-12 mb-1"
          size="md"
        >
          <b-form-select-option key="null" :value="{}"
            >Seleccione una variable</b-form-select-option
          >
          <b-form-select-option-group
            v-for="(var_type, key) in listVariables"
            :key="key"
            :label="key"
          >
            <b-form-select-option
              v-for="(variable, key2) in var_type"
              :key="key2"
              :value="variable"
            >
              {{ variable.label }}
            </b-form-select-option>
          </b-form-select-option-group>
        </b-form-select>
        <b-form-select
          v-model="dependentVariable.condition"
          size="md"
          class="col-md-12 mb-1"
        >
          <b-form-select-option value="IN" selected
            >Igual a</b-form-select-option
          >
          <b-form-select-option value="NOT_IN">Diferente</b-form-select-option>
        </b-form-select>
        <b-list-group
          class="col-md-12 mb-1"
          v-if="'config' in dependentVariable.variable"
        >
          <b-list-group-item
            v-for="(option, key) in dependentVariable.variable.config
              .listOptions"
            :key="
              `dep-${dependentVariable.variable.label}-${key}-${
                option.selected
              }`
            "
            class="d-flex justify-content-between align-items-center py-1"
            :variant="`${!!option.selected ? 'info' : ''}`"
          >
            {{ option.value }}
            <b-form-checkbox v-model="option.selected" inline></b-form-checkbox>
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" pill variant="primary" @click="configVariable">
          Aceptar
        </b-button>
        <b-button
          size="sm"
          pill
          @click="
            cancel()
            actionToClean = false
          "
        >
          Cancelar
        </b-button>
        <b-button
          v-if="!actionToClean && itemExtraConfig.extra_config.depends"
          :data-id="actionToClean"
          variant="warning"
          size="sm"
          pill
          @click="actionToClean = true"
        >
          Limpiar
        </b-button>
        <b-button
          v-else-if="actionToClean"
          :data-id="actionToClean"
          size="sm"
          variant="danger"
          pill
          @click="cleanVariable()"
        >
          ¿Está seguro?
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import { Drag, Drop, DropList } from 'vue-easy-dnd'
import PageHeader from '@components/page-header'
import CsvLoader from 'vue-csv-loader'
import _ from 'lodash'

import { formMethods, variablesMethods, usersMethods } from '@state/helpers'

import InputText from '@components/form/InputText'
import InputTextarea from '@components/form/InputTextarea'
import InputSelect from '@components/form/InputSelect'
import InputMultiSelect from '@components/form/InputMultiSelect'
import InputRadio from '@components/form/InputRadio'
import InputCheckbox from '@components/form/InputCheckbox'
import InputDate from '@components/form/InputDate'

import RenderVariable from '@views/variables/renderVariable.vue'

export default {
  page: {
    title: 'Formularios',
  },
  components: {
    Layout,
    PageHeader,
    Drag,
    Drop,
    DropList,
    InputText,
    InputTextarea,
    InputRadio,
    InputSelect,
    InputMultiSelect,
    InputCheckbox,
    RenderVariable,
    CsvLoader,
    InputDate,
  },
  data() {
    let populateTypeObj = [
      { id: 'all', name: 'Medellín Completo' },
      { id: 'urban', name: 'Zona Urbana' },
      { id: 'rural', name: 'Zona Rural' },
    ]
    let stateObj = [{ id: 'A', name: 'Activo' }, { id: 'I', name: 'Inactivo' }]
    return {
      test: null,
      isSaving: false,
      tabIndex: 0,
      lastTabError: null,
      title: 'Form',
      locale: 'es',
      formData: {},
      editMode: false,
      excluded_vars: [],
      modalExtraConfig: false,
      modalPreview: false,
      modalManagers: false,
      listVariables: {},
      itemExtraConfig: {},
      dependentVariable: {},
      actionToClean: false,
      lastChange: Date.now(),
      formHome: false,
      secretaries: [],
      communes: [],
      secretariesLoading: false,
      indicatorsLoading: false,
      projectsLoading: false,
      communesLoading: false,
      neighborhoodsLoading: false,
      secretariesOptions: [],
      managersOptions: [],
      indicatorsOptions: [],
      projectsOptions: [],
      communesOptions: [],
      neighborhoodsOptions: [],
      secretaries_ids: [],
      communes_ids: [],
      populationTypeOptions: populateTypeObj,
      stateOptions: stateObj,
      extendedVariableSearch: '',
      dimensions: {},
      dimensionsOrder: {},

      form: {
        id: null,
        title: '',
        formHome: false,
        secretaries: [],
        goal: null,
        pub_state: '',
        geographicCoverage: null,
        populationType: populateTypeObj.filter((x) => x.id === 'all')[0],
        communes: null,
        neighborhoods: null,
        targetPopulation: null,
        indicators: [],
        project: null,
        isPermanent: false,
        fillByHouseHold: false,
        startAt: null,
        endAt: null,
        periodicity: null,
        timeFrame: null,
        fillBycitizen: false,
        state: stateObj.filter((x) => x.id === 'A')[0],
        managers: [],
      },
      extended_variables: [],
      base_variables: [],
      pubStatesOptions: [
        { id: '', text: 'Sin guardar' },
        { id: 'N', text: 'No Publicado' },
        { id: 'P', text: 'Publicado' },
        { id: 'X', text: 'Pausado' },
      ],
      timeFrameOptions: [
        { id: null, name: 'Seleccione una Opción' },
        { id: 'day', name: 'Dia(s)' },
        { id: 'week', name: 'Semana(s)' },
        { id: 'month', name: 'Mes(es)' },
        { id: 'year', name: 'Año(s)' },
      ],
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Formularios',
          active: true,
        },
      ],
      lists: [],
      UsersList: [],
      managersError: { title: '', errors: [] },
      showDismissibleManagerAlert: false,
      extraButtons: [
        {
          variant: 'success',
          title: 'Listar Formularios',
          to: { name: 'formList' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },

  watch: {
    secretaries: {
      deep: true,
      handler(newValue, oldValue) {
        if (Object.keys(this.secretaries).length > 0) {
          const ids = this.secretaries
            .map((x) => x.id)
            .sort((a, b) => {
              return a - b
            })
          const sec_ids = this.secretaries_ids.sort((a, b) => {
            return a - b
          })
          if (JSON.stringify(ids) !== JSON.stringify(sec_ids)) {
            this.form.secretaries = this.secretaries
            this.getIndicatorsOptions(ids)
            this.getProjectsOptions(ids)
            this.secretaries_ids = ids
          }
        } else {
          this.secretaries_ids = []
          this.indicatorsOptions = []
          this.projectsOptions = []
          this.form.secretaries = []
          this.form.indicators = []
          this.form.project = null
        }
      },
    },
    communes: {
      deep: true,
      handler(newValue, oldValue) {
        if (Object.keys(this.communes).length > 0) {
          const ids = this.communes.map((x) => x.id)
          if (JSON.stringify(ids) !== JSON.stringify(this.communes_ids)) {
            this.form.communes = this.communes
            this.getNeighborhoodsOptions(ids)
            this.communes_ids = ids
          }
        } else {
          this.communes_ids = []
          this.form.communes = []
          this.form.neighborhoods = []
        }
      },
    },
    form: {
      deep: true,
      handler(newValue, oldValue) {
        if (!newValue.isPermanent) {
          this.form.startAt = null,
          this.form.endAt = null
        }
      },
    },
  },

  mounted() {
    this.secretariesLoading = true // to hide another tabs
    if (this.$route.params.formId) {
      this.editMode = true
      this.isSaving = true
      this.getForms({ formId: this.$route.params.formId }).then((data) => {
        this.prepareForm(data)
        this.isSaving = false
      })
    } else {
      this.editMode = false
      this.getSecretarities()
      this.getDimensionsData()
      this.getManagers()
    }
  },

  methods: {
    ...formMethods,
    ...variablesMethods,
    ...usersMethods,
    prepareForm(data) {
      this.form = { ...data }
      delete this.form.dimensions
      let populationType = this.populationTypeOptions.filter(
        (x) => x.id === data.populationType
      )[0]
      this.form.populationType = populationType
        ? populationType
        : this.populationTypeOptions[0]
      this.form.state = this.stateOptions.filter((x) => x.id === data.state)[0]
      this.form.timeFrame = this.timeFrameOptions.filter(
        (x) => x.id === data.timeFrame
      )[0]

      this.secretaries_ids = data.secretaries
      this.communes_ids = data.communes
      const base_variables = data.dimensions.map((x) => {
        return {
          id: x.id,
          name: x.name,
          order: x.order,
          dimension_id: x.dimension_id,
          form: x.form,
          items: x.base_variables,
        }
      })
      const extended_variables = data.dimensions
        .map((x) => {
          return {
            id: x.id,
            name: x.name,
            order: x.order,
            dimension_id: x.dimension_id,
            form: x.form,
            items: x.extended_variables,
          }
        })
        .filter((y) => y.items.length > 0)
        .sort((a, b) => (a.name > b.name && 1) || -1)

      this.getSecretarities(data.secretaries)
      this.getCommunesOptions(
        { id: data.populationType ? data.populationType : 'all' },
        data.communes
      )
      this.getNeighborhoodsOptions(data.communes, data.neighborhoods)
      this.getIndicatorsOptions(data.secretaries, data.indicators)
      this.getProjectsOptions(data.secretaries, data.project)

      this.getDimensionsData(base_variables, extended_variables)
      this.getManagers(data.managers)
    },

    getManagers(default_data = null) {
      let _ = this
      const promise = this.fetchUsers('?page_size=999&lite=true&groups__in=2')
      return promise
        .then((data) => {
          _.managersOptions = data.results.map((item) => {
            return {
              id: item.id,
              username: item.username,
              name: `${item.username || item.id} - ${item.first_name ||
                item.username} ${item.last_name}`,
            }
          })
          if (default_data) {
            _.managers = _.managersOptions.filter((x) =>
              default_data.includes(x.id)
            )
            _.form.managers = _.managers
          }
        })
        .catch((error) => {
          console.log('Se presento un error con los gestores', error)
        })
    },

    getSecretarities(default_data = null) {
      let _ = this
      const promise = this.getSecretaries('?page_size=999')
      this.secretariesLoading = true
      return promise
        .then((data) => {
          _.secretariesLoading = false
          _.secretariesOptions = data.results.map((item) => {
            return {
              id: item.id,
              name: item.name,
            }
          })
          if (default_data) {
            _.secretaries = _.secretariesOptions.filter((x) =>
              default_data.includes(x.id)
            )
            _.form.secretaries = _.secretaries
          }
        })
        .catch((error) => {
          _.secretariesLoading = false
          console.log('Se presento un error con las secretarias', error)
        })
    },

    getIndicatorsOptions(ids, default_data = null) {
      let _ = this
      const query = '?page_size=999&secretaryship_id__in=' + ids
      _.indicatorsLoading = true
      const promise = _.getIndicators(query)
      return promise
        .then((data) => {
          _.indicatorsLoading = false
          _.indicatorsOptions = data.results.map((item) => {
            return {
              id: item.id,
              name: item.name,
              secretaryship_name: item.secretaryship_name,
            }
          })
          if (default_data) {
            _.form.indicators = _.indicatorsOptions.filter((x) =>
              default_data.includes(x.id)
            )
          } else if (_.form.indicators !== null) {
            _.form.indicators = _.indicatorsOptions
              .map((x) => x.id)
              .filter((x) => _.form.indicators.map((x) => x.id).includes(x))
          }
        })
        .catch((error) => {
          console.log('Se presento un error con los indicadores', error)
        })
    },

    getProjectsOptions(ids, default_data = null) {
      let _ = this
      const query = '?page_size=999&secretaryship_id__in=' + ids
      _.projectsLoading = true
      const promise = _.getProjects(query)
      return promise
        .then((data) => {
          _.projectsLoading = false
          _.projectsOptions = data.results.map((item) => {
            return {
              id: item.id,
              name: item.name,
              secretaryship_name: item.secretaryship_name,
            }
          })
          if (default_data) {
            _.form.project = _.projectsOptions.filter(
              (x) => default_data === x.id
            )
          } else {
            _.form.project = _.projectsOptions
              .map((x) => x.id)
              .filter((x) => _.form.project === x)
          }
        })
        .catch((error) => {
          _.projectsLoading = false
          console.log('Se presento un error con los proyectos', error)
        })
    },

    getCommunesOptions(type, default_data = null) {
      let _ = this
      const query = '?page_size=999&type=' + type.id
      if (type.id !== 'all') {
        _.communesLoading = true
        const promise = _.getCommunes(query)
        return promise
          .then((data) => {
            _.communesLoading = false
            _.communesOptions = data.results.map((item) => {
              return {
                url: item.url,
                id: item.id,
                name: item.name,
                number: item.number,
                type: item.type,
              }
            })
            if (default_data) {
              _.communes = _.communesOptions.filter((x) =>
                default_data.includes(x.id)
              )
              _.form.communes = _.communes
            } else {
              _.communes = null
              _.form.communes = null
              _.form.neighborhoods = null
            }
          })
          .catch((error) => {
            _.communesLoading = false
            console.log('Se presento un error con las comunas', error)
          })
      } else {
        _.form.communes = null
        _.form.neighborhoods = null
      }
    },

    getNeighborhoodsOptions(ids, default_data = null) {
      if (ids === null) {
        return true
      }
      const query = '?page_size=199&commune_id__in=' + ids
      this.neighborhoodsLoading = true
      const promise = this.getNeighborhoods(query)
      return promise
        .then((data) => {
          this.neighborhoodsLoading = false
          this.neighborhoodsOptions = data.results.map((item) => {
            return {
              id: item.id,
              name: item.name,
              commune: item.commune,
              commune_name: item.commune_name,
            }
          })
          if (default_data) {
            this.form.neighborhoods = this.neighborhoodsOptions.filter((x) =>
              default_data.includes(x.id)
            )
          } else {
            if (this.form.neighborhoods) {
              const finded = this.neighborhoodsOptions
                .map((x) => x.id)
                .filter((x) =>
                  this.form.neighborhoods.map((x) => x.id).includes(x)
                )
              this.form.neighborhoods = this.form.neighborhoods.filter((x) =>
                finded.includes(x.id)
              )
            } else {
              this.form.neighborhoods = []
            }
          }
        })
        .catch((error) => {
          this.neighborhoodsLoading = false
          console.log('Se presento un error con los barrios', error)
        })
    },
    ordenarvariable(data) {
      data.sort((a, b) => {
        const nameA = a.name.split(' ')
        const nameB = b.name.split(' ')
        const nameAComplete = `${nameA[0]} ${nameA[nameA.length - 1]}`
        const nameBComplete = `${nameB[0]} ${nameB[nameB.length - 1]}`

        if (nameAComplete > nameBComplete) {
          return 1
        }
        if (nameAComplete < nameBComplete) {
          return -1
        }
        return 0
      })
    },
    getDimensionsData(
      default_base_variables = null,
      default_ext_variables = null
    ) {
      this.getDimensions('?page_size=999')
        .then((data) => {
          const dataOrder = _.cloneDeep(data.results)
          this.ordenarvariable(dataOrder)
          this.dimensionsOrder = dataOrder
          this.dimensions = _.cloneDeep(data.results)
          this.base_variables = data.results.map((x) => {
            return {
              id: x.id,
              name: x.name,
              order: x.order,
              items: x.base_variables,
            }
          })
          if (default_ext_variables) {
            this.extended_variables = default_ext_variables
            // remove from dimensions/extended_variables, the used in this form
            const flatted_ev = default_ext_variables
              .map((z) => {
                return z.items.map((z1) => {
                  return z1.variable
                })
              })
              .flatMap((x) => x)
            this.dimensions.forEach((x) => {
              x.extended_variables.forEach((y) => {
                if (flatted_ev.includes(y.variable)) {
                  x.extended_variables = x.extended_variables.filter(function(
                    item
                  ) {
                    return item.variable !== y.variable
                  })
                }
              })
            })
          }
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de las variables extendidas',
            error
          )
        })
    },

    previewForm() {
      this.modalPreview = true
    },
    managersForm() {
      this.modalManagers = true
      this.$nextTick(() => {
        this.$refs.fileLoader.$el.children[0][1].setAttribute('accept', '.csv')
      })
    },

    saveManagers(bvModalEvt) {
      bvModalEvt.preventDefault()
      let _ = this
      if (_.form.managers.length > 0) {
        this.createFormsManaged({
          form: _.form.id,
          managers: _.form.managers,
        }).then((data) => {
          if (data.error.length !== 0) {
            _.$generate_noty(
              'warn',
              `Hay ${data.error.length} errores en los gestores ingresados`
            )
            _.managersError.title = `Gestores no asignados (no existen en medellin.gov.co)`
            _.managersError.errors = data.error
            _.showDismissibleManagerAlert = true
          } else {
            _.$generate_noty(
              'success',
              `${data.success.length} Gestores asignados satisfactoriamente`
            )
            _.getManagers(data.success)
            _.showDismissibleManagerAlert = false
            _.$nextTick(() => {
              _.$bvModal.hide('managers-modal')
              _.managersError = { title: '', errors: [] }
            })
          }
        })
      } else {
        this.createFormsManaged({
          form: _.form.id,
          managers: [],
        }).then((data) => {
          if (data.status === '200') {
            _.$generate_noty(
              'success',
              `Gestores eliminados satisfactoriamente!`
            )
            _.getManagers([])
            _.showDismissibleManagerAlert = false
            _.$nextTick(() => {
              _.$bvModal.hide('managers-modal')
              _.managersError = { title: '', errors: [] }
            })
          }
        })
      }
    },

    saveForm(action = null) {
      this.isSaving = true
      let _ = this
      // first tab (methodological sheet)
      if (
        this.tabIndex === 0 ||
        this.form.id === null ||
        ['publicate', 'pause'].includes(action)
      ) {
        this.form.pub_state =
          action === 'publicate'
            ? 'P'
            : action === 'pause'
            ? 'X'
            : this.form.pub_state === ''
            ? 'N'
            : this.form.pub_state
        let data = { ...this.form }
        data.secretaries = this.form.secretaries.length
          ? this.form.secretaries.map((x) => {
              return x.id
            })
          : null
        data.communes = this.form.communes
          ? this.form.communes.map((x) => {
              return x.id
            })
          : null
        data.neighborhoods = this.form.neighborhoods
          ? this.form.neighborhoods.map((x) => {
              return x.id
            })
          : null
        data.indicators =
          this.form.indicators && this.form.indicators.length
            ? this.form.indicators.map((x) => {
                return x.id
              })
            : null
        data.populationType = this.form.populationType.id
        data.project = this.form.project ? this.form.project.id : null
        data.state = this.form.state ? this.form.state.id : null
        data.timeFrame = this.form.timeFrame ? this.form.timeFrame.id : null
        data.startAt = this.form.isPermanent ? this.form.startAt : null
        data.endAt = this.form.isPermanent ? this.form.endAt : null

        const promise = this.createForm(data)
        return promise
          .then((data) => {
            _.isSaving = false
            _.form.id = data.id

            _.$generate_noty(
              'success',
              `Formulario ${
                _.form.id !== null ? 'actualizado' : 'creado'
              } satisfactoriamente`
            )
            if (_.tabIndex === 0) {
              _.$nextTick(() => {
                _.tabIndex++
                // return
              })
            }
          })
          .catch((error) => {
            _.isSaving = false
            _.$generate_noty('error', error)
            console.log(
              'Se presento un error en la creacion del formulario.',
              error
            )
          })
      } else if (this.tabIndex === 1) {
        // second tab (base variables)
        this.tabIndex++
        this.isSaving = false
        return
      }

      if (this.tabIndex === 2 && this.form.id !== null) {
        // third tab (extended variables)
        this.isSaving = true

        let data = {
          variables: { ...this.extended_variables },
          deleted_variables: this.excluded_vars,
          form: this.form.id,
        }
        if (this.extended_variables.length > 0) {
          const promise = this.createFormExtVars(data)
          return promise
            .then((data) => {
              _.isSaving = false
              _.$generate_noty(
                'success',
                `Variables extendidas ${
                  _.form.id !== null ? 'actualizadas' : 'creadas'
                } satisfactoriamente`
              )
              this.$router.push({ name: 'formList' })
            })
            .catch((error) => {
              _.isSaving = false
              _.$generate_noty('error', error)
              console.log(
                'Se presento un error en la creacion del formulario.',
                error
              )
            })
        } else {
          _.isSaving = false
          _.$generate_noty('info', 'No se almacenaron las variables extendidas')
          this.$router.push({ name: 'formList' })
        }
      }
    },

    getVariableSearch(variables, search) {
      return variables.filter((varia) => {
        {
          return varia.label.toLowerCase().includes(search.toLowerCase())
        }
      })
    },

    openModalExtraConfig(item) {
      this.dependentVariable = { condition: 'IN', variable: {} }
      this.itemExtraConfig = item
      this.getListVariables()
      this.modalExtraConfig = true
    },

    insertSection(event, dimension) {
      dimension.splice(event.index, 0, event.data)
    },

    onDrop(e) {
      let _ = this
      e.data.id = _.editMode ? e.data.id : null
      const form_dimension_idx = _.extended_variables.findIndex(
        (x) => x.dimension_id === e.data.dimension
      )
      const dimension = _.dimensions.filter((x) => x.id === e.data.dimension)[0]
      if (form_dimension_idx > -1) {
        _.extended_variables[form_dimension_idx].items.push(e.data)
      } else {
        _.extended_variables.push({
          name: dimension.name,
          order: dimension.order,
          id: dimension.id,
          dimension_id: dimension.id,
          items: [e.data],
        })
      }
      // _.$generate_noty('success', `Variable ${e.data.label} agregada, dimensión ${dimension.name}!`, 2400)

      // PARA HACER SCROLL A LA SECCIÓN AGREGADA:
      // _.$nextTick(() => {
      //   _.$refs[`section-${dimension.id}`][0].scrollIntoView({
      //     behavior: 'smooth'
      //   });
      // })
      this.lastChange = Date.now()
    },

    dragOver(e) {
      // console.log(e)
    },

    removeVariable(array = [], value = {}, type = '') {
      if (value.extra_config.depends != undefined) {
        this.$generate_noty(
          'warn',
          `La variable a eliminar tiene una dependencia, debes elimnar la dependencia para continuar`
        )
      } else {
        if (array.length > 0) {
          let index = array.indexOf(value)
          if ('variable_form_id' in value) {
            this.excluded_vars.push(value.variable_form_id)
          }
          array.splice(index, 1)
        }
        if (type === 'restore') {
          const dimension_index = this.dimensionsOrder
            .map((o) => {
              return o.id
            })
            .indexOf(value.dimension)
          this.dimensionsOrder[dimension_index].extended_variables.splice(
            0,
            0,
            value
          )
          this.cleanVariable(value)
        }
        this.lastChange = Date.now()
      }
    },

    addSection() {
      this.extended_variables.push({
        name: 'Sección ' + (parseInt(this.extended_variables.length) + 1),
        items: [],
      })
      this.lastChange = Date.now()
    },

    moveSection(actual_index, new_index) {
      const section_name = this.extended_variables[actual_index].name
      if (new_index >= this.extended_variables.length) {
        let k = new_index - this.extended_variables.length + 1
        while (k--) {
          this.extended_variables.push(undefined)
        }
      }
      this.extended_variables.splice(
        new_index,
        0,
        this.extended_variables.splice(actual_index, 1)[0]
      )
      this.extended_variables.forEach((x, y) => {
        x.order = y
      })
      this.$generate_noty('success', `Sección ${section_name} movida`, 2000)
      this.lastChange = Date.now()
    },

    removeSection(index) {
      let _ = this
      const section_name = this.extended_variables[index].name
      const variables_count = this.extended_variables[index].items.length
      this.extended_variables[index].items.forEach((variable) => {
        _.removeVariable(_.extended_variables[index].items, variable, 'restore')
      })
      this.extended_variables.splice(index, 1)
      this.$generate_noty(
        'success',
        `Sección ${section_name} eliminada${
          variables_count > 0
            ? `, ${variables_count} variables restauradas`
            : ''
        }`,
        2000
      )
      this.lastChange = Date.now()
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    async tabActivated(newTabIndex, prevTabIndex, bvEvent) {
      if (this.$refs['observer'].observers[prevTabIndex] !== undefined) {
        const valid = await this.$refs['observer'].observers[
          prevTabIndex
        ].validate()
        if (!valid && this.lastTabError === null) {
          this.lastTabError = prevTabIndex
          bvEvent.preventDefault()
          this.$generate_noty(
            'error',
            `Hay errores en el formulario ${
              this.$refs['tabs'].registeredTabs[prevTabIndex].title
            }, verifique`
          )
          await this.sleep(400)
          this.tabIndex = prevTabIndex
        } else {
          this.lastTabError = null
        }
      }
    },

    getListVariables() {
      let _ = this
      let finded = false
      let current = this.itemExtraConfig
      let list_variables = {
        Base: [],
        Extendidas: [],
      }
      _.extended_variables.forEach((element) => {
        element.items.forEach((element2) => {
          if (
            (element2.type === 'list' || element2.type === 'boolean') &&
            element2.variable !== current.variable
          ) {
            if (element2.type === 'boolean') {
              element2.config.listOptions = [
                { key: 'true', value: 'verdadero' },
                { key: 'false', value: 'falso' },
              ]
            }
            list_variables.Extendidas.push(element2)
            if (element2.variable === parseInt(current.extra_config.depends)) {
              finded = true
              _.dependentVariable.variable = element2
              _.dependentVariable.condition =
                current.extra_config.depends_condition
              _.dependentVariable.variable.config.listOptions = _.dependentVariable.variable.config.listOptions.map(
                (x) => {
                  return {
                    ...x,
                    selected: current.extra_config.depends_value
                      .map((o) => o.trim())
                      .includes(x.key.trim()),
                  }
                }
              )
            }
          }
        })
      })
      if (Object.keys(_.dimensions).length > 0) {
        _.dimensions.forEach((element) => {
          element.base_variables.forEach((element2) => {
            if (
              (element2.type === 'list' || element2.type === 'boolean') &&
              element2.variable !== current.variable
            ) {
              list_variables.Base.push(element2)
              if (
                element2.variable === parseInt(current.extra_config.depends)
              ) {
                finded = true
                _.dependentVariable.variable = element2
                _.dependentVariable.condition =
                  current.extra_config.depends_condition
                _.dependentVariable.variable.config.listOptions = _.dependentVariable.variable.config.listOptions.map(
                  (x) => {
                    return {
                      ...x,
                      selected: current.extra_config.depends_value
                        .map((o) => o.trim())
                        .includes(x.key.trim()),
                    }
                  }
                )
              }
            }
          })
        })
      }
      if (!finded) {
        this.dependentVariable = { condition: 'IN', variable: {} }
      }
      this.listVariables = { ...list_variables }
      this.lastChange = Date.now()
    },

    configVariable() {
      let _ = this
      if (Object.keys(_.dependentVariable.variable).length === 0) {
        // si limpia la opción manualmente y guarda
        _.dependentVariable.variable = _.getVariableInfoById(
          _.itemExtraConfig.extra_config.depends
        )
        _.cleanVariable(_.itemExtraConfig)
        return
      }
      _.itemExtraConfig.extra_config.depends =
        _.dependentVariable.variable.variable
      _.itemExtraConfig.extra_config.depends_condition =
        _.dependentVariable.condition
      _.itemExtraConfig.extra_config.depends_value = _.dependentVariable.variable.config.listOptions
        .filter((x) => x.selected)
        .map((x) => x.key)
      let dependent_var = _.getVariableInfoById(
        _.dependentVariable.variable.variable
      )

      let dependents = []
      _.extended_variables.forEach((section) => {
        section.items
          .filter(
            (x) =>
              parseInt(x.extra_config.depends) ===
              _.dependentVariable.variable.variable
          )
          .map((y) => y.variable)
          .forEach((id) => {
            dependents.push(id)
          })
      })
      dependent_var.extra_config.dependents = dependents
      // _.$generate_noty('success', `Condiciones de variable configuradas`)
      _.modalExtraConfig = false
      this.lastChange = Date.now()
    },

    cleanVariable(variable) {
      let _ = this
      _.actionToClean = false
      let dependent_var = null
      let dependents = []

      if (!variable) {
        variable = _.itemExtraConfig
        delete variable.extra_config.depends
        delete variable.extra_config.depends_condition
        delete variable.extra_config.depends_value
        dependent_var = _.getVariableInfoById(
          _.dependentVariable.variable.variable
        )
      } else {
        dependent_var = _.getVariableInfoById(variable.extra_config.depends)
        delete variable.extra_config.depends
        delete variable.extra_config.depends_condition
        delete variable.extra_config.depends_value
      }

      _.extended_variables.forEach((section) => {
        section.items
          .filter(
            (x) => parseInt(x.extra_config.depends) === dependent_var.variable
          )
          .map((y) => y.variable)
          .forEach((id) => {
            dependents.push(id)
          })
      })
      if (Object.keys(dependent_var).length > 0) {
        dependent_var.extra_config.dependents = dependents
      }
      _.dependentVariable = {}
      // variable = {}
      // _.$generate_noty('success', `Condiciones de variable actualizadas`)
      _.modalExtraConfig = false
      this.lastChange = Date.now()
    },

    getVariableInfoById(id) {
      let variable = []
      this.dimensions.forEach((element) => {
        element.base_variables.forEach((element2) => {
          if (element2.variable === parseInt(id)) {
            variable = element2
          }
        })
        element.extended_variables.forEach((element2) => {
          if (element2.variable === parseInt(id)) {
            variable = element2
          }
        })
      })
      this.extended_variables.forEach((element) => {
        element.items.forEach((element2) => {
          if (element2.variable === parseInt(id)) {
            variable = element2
          }
        })
      })
      return variable
    },
    loadSuccess(result) {
      try {
        // console.log(result)
        let tempList = 0
        let errorsList = []
        _ = this
        result.csvBody.forEach((row, index) => {
          const user = String(row[0] || '').replace('\n', '')
          if (user !== '') {
            const newUser = {
              id: user,
              username: user,
              name: `${user} - Creación Pendiente`,
            }
            if (
              _.managersOptions.filter((x) => x.username === newUser.id)
                .length === 0
            ) {
              _.managersOptions.push(newUser)
              _.form.managers.push(newUser)
            } else {
              if (
                _.form.managers.filter((x) => x.username === newUser.id)
                  .length === 0
              ) {
                _.form.managers.push(
                  _.managersOptions.filter((x) => x.username === newUser.id)[0]
                )
              }
            }
            tempList++
          } else {
            errorsList.push(index)
          }
        })
        if (errorsList.length > 0) {
          this.$generate_noty(
            'warn',
            `Hay ${
              errorsList.length
            } registros que no tienen la estructura adecuada, verifique las filas ${errorsList.join(
              ','
            )} en su archivo`,
            'Carga de archivo CSV',
            8000
          )
        }
        if (tempList > 0) {
          this.$generate_noty(
            'success',
            `Listado cargado exitosamente (${tempList} registros)<br>Recuerde <b>Guardar</b>`,
            'Carga de archivo CSV'
          )
        } else {
          this.$generate_noty(
            'warn',
            `El archivo no procesado, verifique. Recuerde que debe ser un archivo CSV y con 1 columna.`,
            'Carga de archivo CSV'
          )
        }
      } catch (error) {
        console.error('error:', error)
        this.$generate_noty(
          'warn',
          `Archivo no procesado, verifique. Recuerde que debe ser un archivo CSV y con 1 columna.`
        )
        return
      }
    },
    addManager(newUser) {
      const newUser_ = {
        id: newUser,
        username: newUser,
        name: `${newUser} - Creación Pendiente`,
      }
      if (
        this.managersOptions.filter((x) => x.username === newUser_.id)
          .length === 0
      ) {
        this.managersOptions.push(newUser_)
        this.form.managers.push(newUser_)
      } else {
        this.form.managers.push(
          this.managersOptions.filter((x) => x.username === newUser_.id)[0]
        )
      }
    },
  },
  computed: {
    filteredList() {
      return this.postList.filter((post) => {
        return post.title.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
}
</script>

<style lang="scss">
#extra-config-modal .custom-select-md {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 0.95rem;
}

.with-separator {
  border-top: 1px solid #dee2e6 !important;
}

.dnd-drag.drag-out.drag-no-handle {
  .list-group-item {
    background-color: #f5fafd;
    color: gray;
    border: #e5eaee 1px solid;
  }
}

.tabs-forms .nav-link.disabled {
  color: gray !important;
}

.extended-vars,
.base-vars {
  .left-panel {
    margin-top: 1px;
  }

  .dimension-title {
    border-top: 1px solid rgb(238, 238, 238);
  }

  .btn.btn-block {
    .opened,
    .closed {
      float: right !important;
      margin-top: 4px;
      color: #226aa7;
      transition: transform 0.15s ease-in-out,
        background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }

    &.collapsed {
      .opened {
        display: none;
      }

      .closed {
        display: inline;
      }
    }

    &.not-collapsed {
      .opened {
        display: inline;
      }

      .closed {
        display: none;
      }
    }
  }

  .search {
    .form-control {
      height: 38px;
      padding-right: 0;
      padding-left: 20px;
      color: #000;
      background-color: rgba(255, 255, 255, 0.07);
      border: 1px solid rgba(0, 0, 0, 0.03);
      border-radius: 30px 0 0 30px;
      border-right: none;
      box-shadow: none;
    }

    .btn {
      color: #2185d0;
      background-color: rgba(255, 255, 255, 0.07);
      border-color: rgba(0, 0, 0, 0.03);
      border-radius: 0 30px 30px 0;
      box-shadow: none !important;
      border-left: none;
    }
  }

  .section-card {
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 10px;
  }

  .list2 {
    min-height: 200px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .card {
      border: 1px dashed #48c0f5;
      border-bottom: 3px solid #48c0f5;
      border-radius: 5px;

      .handle-cursor:hover {
        background-color: #48c1f51f;
      }

      &.dependent {
        border: 1px dashed #f7b84b;
        border-bottom: 3px solid #f7b84b;

        svg {
          color: #c79e51 !important;
        }

        .handle-cursor:hover {
          background-color: #ffbb4625;
        }
      }

      .handle-cursor {
        cursor: move;
      }
    }

    &.empty {
      text-align: center;
      // background-color: #f5fafd;
      padding: 10px;
    }

    &.empty::after {
      content: 'Arrastre y suelte la variable aquí';
      background-image: url('~~~@assets/images/add-form-img.png');
      background-position: center center;
      background-repeat: no-repeat;
      color: rgb(204, 204, 204);
      font-size: 14px;
      width: 100%;
      text-align: center;
      margin-top: 18px;
    }

    &.drop-allowed.empty::after {
      content: 'Suelte aquí para insertar la variable';
      background-image: none;
      font-size: 16px;
    }

    &.drop-forbidden {
      background-color: rgba(255, 0, 0, 0.12);
    }

    &.drop-allowed {
      background-color: rgba(61, 65, 255, 0.12);
    }
  }

  .section-name {
    .form-control {
      background-color: transparent !important;
      border: transparent !important;
      font-size: 18px;
    }

    .input-group-text {
      background-color: transparent !important;
      border: none;
    }
  }
}

#csv-to-table {
  margin: 10px 1px 3px 1px;

  label.label,
  .field-body .field,
  span.file-label,
  .file-input,
  .file-name {
    display: none;
  }

  .file-icon::after {
    content: 'Cargar desde archivo (.csv)';
    margin-left: 5px;
    color: rgb(73, 73, 73);
  }

  .file-cta {
    border: 1px solid rgb(207, 207, 207);
    padding: 10px;
    border-radius: 5px;
    font-weight: normal;

    &:hover {
      background-color: rgb(240, 240, 240);
      cursor: pointer;
    }
  }
}
</style>
